export const AlertTypes = {
    Heat: "Heat",
    RepeatHeat: "Repeat Heat",
    LowWaterIntake: "Low Water Intake",
    Calving: "Calving",
    LowTemp: "Low Temp",
    PossibleMilkFever: "Possible Milk Fever",
    HighTemp: "High Temp",
    IncreasedActivity: "Increased Activity",
    DecreasedActivity: "Decreased Activity",
    // Local client categories
    Alerts: "Alerts",
    LowCoverage: "Low Coverage",
    NetworkFailure: "Network Failure",
    OutOfRange: "Out of Range"
}


// WEBPACK FOOTER //
// ./src/constants/alert_types.js